import { Link } from 'react-router-dom';
import Logo from '../assets/images/Logo.svg';
// import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import React, { useState, useEffect, useRef } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import timelineData from '../components/timeline.json';
import DotsMap from './../components/DotsMap';

import { getPin } from './../assets/scripts/get-points.js';

function mapToProp(data, prop) {
  return data.reduce(
    (res, item) =>
      Object.assign(res, {
        [item[prop]]: 1 + (res[item[prop]] || 0),
      }),
    Object.create(null)
  );
}

function Map() {
  // console.log(timelineData);

  const [mapHeight, setHeight] = useState(900);
  const [mapWidth, setWidth] = useState(1000);
  const ref = useRef(null);

  const mapAndCountByLocation = mapToProp(timelineData, 'Location');
  const uniqueDates = [...new Set(timelineData.map((item) => item.Year))];

  // For styling date slider/picker
  const steplist = [
    5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95,
    100,
  ];
  // ---------------------- sidebar function to open and close -----------------------
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // --------------------end sidebar ------------------

  // Set start and End dates
  const startDate = Math.min(...timelineData.map((item) => item.Year));
  // const endDate = Math.max(...timelineData.map((item) => item.Year));
  // After you slide slider, set new array of event by date.
  const [newObjectArr, setNewObjectArr] = useState([{
    x: getPin(timelineData[0]['Latitude'], timelineData[0]['Longitude'], mapHeight, mapWidth).x,
    y: getPin(timelineData[0]['Latitude'], timelineData[0]['Longitude'], mapHeight, mapWidth).y,
    id: 0,
    Location: "DuPont Company\u2019s Jackson Laboratory",
    Latitude: 39.6875886,
    Longitude: -75.4906483,
    Year: 1938,
    Description: "Roy J. Plunkett accidentally invented polytetrafluorethylene (PTFE), a saturated fluorocarbon polymer, which is known as the first PFAS compound to be marketed commercially. PTFE is later to be widely known as Teflon.",
    Reference: "https://www.sciencehistory.org/historical-profile/roy-j-plunkett"
  }]);

  // dynamic visualization of input range.
  const [inputValue, setInputValue] = useState('0');

  // console.log(newObjectArr);

  // Change array items count by selected date
  function handleChangeValue(e) {
    // add 0.01 just for increase number that he wuold be greater than date in list.
    let sliderDate = uniqueDates[e.target.value] + 0.01;
    // just for imput visualization
    setInputValue(e.target.value);
    // filter througth all date to selected date
    let arrayUntillDate = timelineData.filter(function (e) {
      return e.Year < sliderDate;
    });
    for (let i = 0; i < arrayUntillDate.length; i++) {
      let thisPin = getPin(arrayUntillDate[i]['Latitude'], arrayUntillDate[i]['Longitude'], mapHeight, mapWidth);
      arrayUntillDate[i]['x'] = thisPin.x;
      arrayUntillDate[i]['y'] = thisPin.y;
    }
    // console.log(arrayUntillDate);

    setNewObjectArr(arrayUntillDate);
  }

  // Set first event by date from timilineData and run only once to pass to maps
  useEffect(() => {
    let setFirstDate = () => {
      let firstEventByYear = timelineData.filter(function (e) {
        return e.Year === startDate;
      });
      setNewObjectArr(firstEventByYear);
    };
    setFirstDate();
  }, [startDate]);

  useEffect(() => {
    setHeight(ref.current.clientHeight);
    setWidth(ref.current.clientWidth);

    let newObjectArr_ = newObjectArr;
    for (let i = 0; i < newObjectArr_.length; i++) {
      let thisPin = getPin(newObjectArr_[i]['Latitude'], newObjectArr_[i]['Longitude'], ref.current.clientHeight, ref.current.clientWidth);
      newObjectArr_[i]['x'] = thisPin.x;
      newObjectArr_[i]['y'] = thisPin.y;
    }
    setNewObjectArr(newObjectArr_);
  })


  return (
    <>
      <div className='navigation'>
        <div className='logo'>
          <img src={Logo} alt='Quantum logo' />
        </div>
        <div className='nav'>
          <Link to='/'>
            <div className='nav-home'></div>
          </Link>

          <div className='nav-page-nr'>1/6</div>

          <Link to='/pfas' className='pfas-btn-blue-next'>
            <div className='nav-text-next'>Next</div>
          </Link>
        </div>
      </div>

      <div className='map pfas-container'>
        <Row>
          <Col>
            <div className='heading-text-center'>
              Use the timeline on the bottom and click on the map markers to
              learn about areas with PFAS contamination around the globe.
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div onClick={handleShow} className='world-map' ref={ref}>
              <DotsMap
                mapHeight={mapHeight}
                mapWidth={mapWidth}
                dots={newObjectArr}
                byLocation={mapAndCountByLocation}
                setShow={setShow}
              />
            </div>
            <div className='map-slider-container'>
              <div className='slidecontainer'>
                <input
                  className='slider'
                  onChange={handleChangeValue}
                  type='range'
                  min='0'
                  max='19'
                  step='1'
                  value={inputValue}
                ></input>
                <datalist id='steplist'>
                  {steplist.map((x) => {
                    return <option key={x} label={uniqueDates[steplist.indexOf(x)]}></option>;
                  })}
                </datalist>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      {/* Offcanvas style is in App.scss file */}
      <Offcanvas show={show} onHide={handleClose} placement='end'>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title className='event-main-title'>
            {newObjectArr.length}{' '}
            {newObjectArr.length === 1 ? 'event' : 'events'} in the world
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {newObjectArr.map((q) => {
            return (
              <>
                <div className='event-single' key={q.id}>
                  <div className='event-date'>{q.Year} | {q.Location}</div>
                  <div className='event-description'>{q.Description}</div>
                  <div className='event-link'>
                    {q.Reference === null ? <p/> :
                      <a href={`${q.Reference}`} target='_blank' rel='noreferrer'>
                        Read more
                      </a>
                    }
                  </div>
                </div>
                <hr />
              </>
            );
          }).reverse()}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default Map;
